import { useState } from 'react'
import { Card, GotchaCallout, PendingLine, asList } from './primitives.jsx'
import w from './widgets.module.css'

/**
 * #5 Gotcha callouts: the traps the skill lists for what was asked. Items
 * attached to another card render there (see buildAnswer); this is the rest.
 */
export function Gotchas({ input, block }) {
  const items = asList(input.items).filter((g) => g?.id && g.title)
  const firstBlocker = items.find((g) => g.severity === 'blocker')?.id
  // Until the user toggles one, the first blocker is open (it may stream in late).
  const [touched, setTouched] = useState(null)
  const open = touched ?? new Set(firstBlocker ? [firstBlocker] : [])
  if (!items.length) {
    return block.complete ? null : (
      <Card title="Watch for">
        <PendingLine />
      </Card>
    )
  }

  const toggle = (id) => {
    const next = new Set(open)
    if (next.has(id)) next.delete(id)
    else next.add(id)
    setTouched(next)
  }

  return (
    <Card
      label={input.title ?? 'Watch for'}
      title={input.title ?? 'Watch for'}
      sub={[input.subject, `${items.length} ${items.length === 1 ? 'item' : 'items'}`].filter(Boolean).join(' · ')}
    >
      <div className={w.glist}>
        {items.map((item) => (
          <GotchaCallout key={item.id} item={item} open={open.has(item.id)} onToggle={() => toggle(item.id)} />
        ))}
      </div>
    </Card>
  )
}
